// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Portals/components/PortalCard/index.css
// module id = 1878
// module chunks = 0